import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Loader = ({ message = "Logging in...", isVisible = true }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // Takes the full height of the viewport
        position: "fixed", // Ensures the loader is fixed and covers the whole screen
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: 1201, // Higher than most app components
      }}
    >
      <Box
        sx={{
          width: 400, // Larger white box
          height: 400, // Larger white box
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 1)", // White background
          borderRadius: "16px", // Rounded corners
          boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)", // Soft shadow around the box
          padding: "20px", // Padding inside the box for spacing
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: 300, // Larger spinner
            height: 300, // Larger spinner
          }}
        >
          <CircularProgress
            variant="indeterminate"
            size={300} // Larger spinner
            thickness={2}
            sx={{
              color: "transparent",
              "& .MuiCircularProgress-circle": {
                strokeLinecap: "round",
                stroke: "url(#my_gradient)",
              },
            }}
          />
          <svg width="0" height="0" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="my_gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#1D3DFC" stopOpacity="10" />
                <stop offset="50%" stopColor="#1D3DFC" stopOpacity="2" />
                <stop offset="100%" stopColor="#1D3DFC" stopOpacity="0.2" />
              </linearGradient>
            </defs>
          </svg>
          <Box
            sx={{
              position: "absolute",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <img
              src="/assets/images/zaviorLogoLightningHero-square.png"
              alt="Zavior Logo"
              style={{
                maxWidth: '126px', // 30% smaller (180px * 0.7 = 126px)
                width: 'auto',
                height: 'auto',
              }}
            />
          </Box>
        </Box>
        
        {message && (
          <Typography
            variant="subtitle1"
            sx={{ mt: 3, color: "#333", fontWeight: "600" }}
          >
            {message}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Loader;
